import { i18n } from '@/locale'

function getGuestFullName (guest) {
  const firstName = getGuestName(guest)
  const lastName = getGuestLastName(guest)
  return lastName ? `${ firstName } ${ lastName }` : firstName
}

function getGuestName (guest) {
  if (!guest.registrationCard && !guest.profile) {
    return i18n.t('checkin.no_name')
  }
  return guest.registrationCard && guest.registrationCard.verifiedDocumentData && guest.registrationCard.verifiedDocumentData !== undefined && guest.registrationCard.verifiedDocumentData.name
    ? guest.registrationCard.verifiedDocumentData.name
    : guest.registrationCard && guest.registrationCard.scannedDocument && guest.registrationCard.scannedDocument !== undefined && guest.registrationCard.scannedDocument.scannedDocumentData && guest.registrationCard.scannedDocument.scannedDocumentData.name
      ? guest.registrationCard.scannedDocument.scannedDocumentData.name
      : guest.profile.name
        ? guest.profile.name
        : i18n.t('checkin.no_name')
}
function getGuestLastName (guest) {
  if (!guest.registrationCard && !guest.profile) {
    return ''
  }
  return guest.registrationCard && guest.registrationCard.verifiedDocumentData && guest.registrationCard.verifiedDocumentData.lastName
    ? guest.registrationCard.verifiedDocumentData.lastName
    : guest.registrationCard && guest.registrationCard.scannedDocument && guest.registrationCard.scannedDocument.scannedDocumentData && guest.registrationCard.scannedDocument.scannedDocumentData.lastName
      ? guest.registrationCard.scannedDocument.scannedDocumentData.lastName
      : guest.profile.lastName
        ? guest.profile.lastName
        : ''
}

export {
  getGuestName,
  getGuestLastName,
  getGuestFullName,
}
